<template>
  <v-footer app class="footer-container">
    <PartnersCaroussel
      v-if="!isAdminRoute"
      :is-member="isMember"
      :is-admin="isAdmin"
      :is-auth-resolved="isAuthResolved"
    />
    <div class="footer-version">Version {{ appVersion }}</div>
  </v-footer>
</template>

<script>
  import PartnersCaroussel from "@/components/pages/river/components/PartnersCaroussel.vue";

  export default {
    name: "AppFooter",
    components: {
      PartnersCaroussel,
    },
    props: {
      appVersion: {
        type: String,
        default: "",
      },
      isMember: {
        type: Boolean,
        default: false,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      isAuthResolved: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isAdminRoute() {
        return typeof this.$route.path === "string" && this.$route.path.startsWith("/admin");
      },
    },
  };
</script>

<style scoped>
  .footer-container {
    z-index: 1000;
  }

  .footer-version {
    position: fixed;
    right: 20px;
    bottom: 6px;
    font-size: 0.75rem;
    color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
    z-index: 1100;
  }

  @media (max-width: 600px) {
    .footer-version {
      display: none;
    }
  }
</style>
